'use client';

import {useEffect, useState} from 'react';

export const getCookieValue = (name: string): string | undefined => {
	if (typeof document === 'undefined') return undefined;
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		const part = parts.pop();
		const cookieValue = part?.split(';').shift();
		if (cookieValue) return encodeURIComponent(cookieValue);
	}
	return undefined;
};

export const useCookie = (name?: string): string | undefined => {
	const [cookieValue, setCookieValue] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (name) {
			const cookieValue = getCookieValue(name);
			setCookieValue(cookieValue);
		}
	}, [name]);
	return cookieValue;
};
